import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'byId',
    standalone: false,
})
export class ByIdPipe implements PipeTransform {
    transform<T>(value: T[], id: number, field?: string): T {
        if (!value) {
            return;
        }
        return value.find(p => p[field || 'id'] === id);
    }
}
